<template>
  <div class="">
    <section v-if="!user">
      <i
        class="mc-close m-bottom-main-slide-modal-header-icon"
        data-bs-dismiss="modal"
      ></i>
      <h1 class="m-bottom-main-slide-modal-header-logo">
        <nuxt-link
          :style="{
            backgroundImage: `url(https://ik.imagekit.io/1pzxddx3qqv/Z54IV3/static/${templateId}/${compId}/header-logo.png)`
          }"
          to="/"
          class="text-unshow logo-link"
        >
          {{ title }}
        </nuxt-link>
      </h1>
    </section>
    <section v-else>
      <i
        class="mc-close m-bottom-main-slide-modal-header-icon"
        data-bs-dismiss="modal"
      ></i>
      <div class="d-flex justify-content-center align-items-center">
        <figure
          v-if="compCommon.vip.enable"
          class="m-bottom-main-slide-modal-header-level-pic"
        >
          <img
            :src="
              `https://ik.imagekit.io/1pzxddx3qqv/Z54IV3/static/${templateId}/${compId}/level/user-level-lv-` +
                user.level +
                '.png'
            "
            :alt="`user-level-lv-${user.level}`"
          />
        </figure>
        <div class="m-bottom-main-slide-modal-header-user-info">
          <h6 class="mb-2 m-bottom-main-slide-modal-header-info-name">
            {{ maskUsername }}
          </h6>
          <h3 class="m-bottom-main-slide-modal-header-info-wallet">
            {{ currencySymbol }}
            {{ currency(user.wallet) }}
          </h3>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { computed, defineComponent, useStore } from '@nuxtjs/composition-api'
import useComp from '../../../composables/useComp'
import useTitle from '../../../composables/useTitle'
import useUser from '../../../composables/useUser'
import usePrice from '../../../composables/usePrice'

export default defineComponent({
  name: 'MainMenuHeader',
  props: {
    name: {
      type: String,
      default: 'MainMenuHeader'
    }
  },
  setup(props, context) {
    const store = useStore()
    const { user, currencySymbol, maskUsername } = useUser(context)
    const { compId, compCommon } = useComp()
    const { title } = useTitle()
    const { currency } = usePrice()

    const templateId = computed(() => process.env.TEMPLATE_ID)
    const isMobile = computed(() => store.state.isMobile)

    return {
      compId,
      compCommon,
      title,
      isMobile,
      templateId,
      user,
      maskUsername,
      currencySymbol,
      useComp,
      currency
    }
  }
})
</script>
